import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { BrowserMenuPageRoutingModule } from './browser-menu-routing.module';

import { BrowserMenuPage } from './browser-menu.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, BrowserMenuPageRoutingModule],
  declarations: [BrowserMenuPage]
})
export class BrowserMenuPageModule {}
